import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.0.3_@babel+core@7.21.0_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/providers.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css")